import EcsEmail, { maxAttachmentsSize } from '@/components/ecs-email/EcsEmail';
import InteractionService from '@/services/interactionService';

const stateActions = {
  createOutgoingEmail: ({ commit, getters, rootGetters }, { businessProcessId, contactId, destination }) => {
    return InteractionService.startEmailInteraction({ businessProcessId }).then(response => {
      if (!response || !response.data || !response.data.interactionId) {
        throw new Error();
      }

      const interactionId = response.data.interactionId;
      const email = new EcsEmail({ interactionId, contactId });

      if (contactId && !destination) {
        const contact = rootGetters['CONTACTS/getContact'](contactId);
        email.outgoingEmailData.to = contact && contact.emails.length ? contact.emails[0].value : '';
      } else {
        email.outgoingEmailData.to = destination || '';
      }

      const fromEmail = rootGetters['REFERENCES/getBusinessProcessDefaultFromEmail'](businessProcessId);
      return InteractionService.getOutgoingEmailSignature(businessProcessId, fromEmail)
        .then(response => {
          email.outgoingEmailData.signature = response.data;
          commit('addEmailData', email);
          return email;
        })
        .catch(() => {
          commit('addEmailData', email);
          return email;
        });
    });
  },

  restoreEmail: ({ dispatch, getters }, event) => {
    const email = getters.getEmailByInteractionId(event.interactionId);
    if (!email) {
      dispatch('addEmailData', email);
    }
  },

  addEmailData: ({ commit }, { event = null, signature }) => {
    if (!event) return;

    const email = new EcsEmail(event, signature);
    commit('addEmailData', email);
  },

  deleteHistoricalEmailsForInteraction: ({ commit }, { interactionId }) => {
    commit('deleteEmailInteraction', interactionId);
  },

  moveEmailToHistory: ({ commit }, payload) => commit('moveEmailToHistory', payload),

  updateSubject: ({ commit }, value) => commit('updateSubject', value),

  removeEmailData: ({ commit }, { interactionId }) => commit('deleteEmailInteraction', interactionId),

  updateEmailResponseBody: ({ commit }, payload) => commit('updateEmailResponseBody', payload),

  updateCcEmails: ({ commit }, payload) => commit('updateCcEmails', payload),

  updateToEmails: ({ commit }, payload) => commit('updateToEmails', payload),

  updateBccEmails: ({ commit }, payload) => commit('updateBccEmails', payload),

  updateRequiredBccEmails: ({ commit }, payload) => commit('updateRequiredBccEmails', payload),

  setOutgoingEmailCreationTime: ({ commit }, payload) => commit('setOutgoingEmailCreationTime', payload),

  setOutgoingEmailAsCanceled: ({ commit }, payload) => commit('setOutgoingEmailAsCanceled', payload),

  setSignatureCursorPosition: ({ commit }, payload) => {
    payload.signatureIndex = payload.signatureIndex < 0 ? 0 : payload.signatureIndex;
    commit('setSignatureCursorPosition', payload);
  },

  addOutgoingAttachments: ({ commit, getters }, payload) => {
    const email = getters.getEmailByInteractionId(payload.interactionId);
    const newAttachmentsSize = payload.attachments.reduce((accum, attachment) => accum + attachment.file.size, 0);
    const attachmentSizeOverflow = email.totalAttachmentsCurrentSize + newAttachmentsSize;
    if (attachmentSizeOverflow > maxAttachmentsSize) {
      payload.attachments = payload.attachments.map(attachment => {
        return { ...attachment, error: true };
      });
    }

    commit('addOutgoingAttachments', payload);
  },

  removeOutgoingAttachment: ({ commit }, payload) => {
    return new Promise(resolve => {
      commit('removeOutgoingAttachment', payload);
      resolve();
    });
  },

  clearAttachments: ({ commit }, payload) => commit('clearAttachments', payload),

  updateValidAttachments: ({ commit, getters }, interactionId) => {
    const email = getters.getEmailByInteractionId(interactionId);
    const attachments = structuredClone(email.outgoingEmailData.attachments);
    const errorAttachments = attachments.filter(a => a.error);
    const attachmentsToUpdate = [];
    if (errorAttachments.length) {
      let availableSize = maxAttachmentsSize - email.validAttachmentsCurrentSize;
      errorAttachments.forEach(attachment => {
        if (availableSize > attachment.file.size) {
          availableSize -= attachment.file.size;
          attachmentsToUpdate.push({ ...attachment, error: false });
        }
      });
      if (attachmentsToUpdate.length) {
        commit('updateValidAttachments', { interactionId, attachmentsToUpdate });
      }
    }
  },

  updateFromEmail: ({ commit }, payload) => commit('updateFromEmail', payload)
};

export default {
  ...stateActions
};
